// import Vue from 'vue'
import * as types from './mutation-types'
// import { filterObj } from '@/utils'
// import login from '@/store/modules/login'
export default {
  [types.SET_IS_LONGIN](state, isLogin) {
    state.isLogin = isLogin
  },
  [types.SET_LOGINST](state, login_info) {
    state.loginInfo = login_info
  },
  [types.SET_IMLOGIN](state, imLogin) {
    state.imLogin = imLogin
  },
  // 初始化IM SIG
  [types.SET_LOGIN_SIG](state, sig) {
    state.im.userSig = sig
  },
  [types.TRY_SWITCH_SESSION](state, id) {
    if (!state.currentSessionID) {
      state.currentSessionID = id
    }
  },
  [types.UPDATE_DEFAULTSESSION](state, session) {
    state.defaultSession = session
  },
  [types.SET_USER_INFO](state, userInfo) {
    state.userInfo = userInfo
  },
  // 保存sessionid
  [types.SET_SESSION_ID](state, sessionId) {
    if (sessionId) {
      state.sessionId = sessionId
    }
  },
  [types.SET_SESSION_ITEM](state, messageItem) {
    state.historyMsgList = messageItem
  },
  // 接收工程师的消息
  [types.UPDATE_USER_SEND_MESSAGE](state, list) {
    for (let i = 0; i < list.length; i++) {
      state.historyMsg.unshift(list[i])
    }
    // state.historyMsg.sort((x, y) => new Date(x.sendTime) - new Date(y.sendTime))
  },
  [types.SET_START_TIME](state, time) {
    state.startTime = time
  },
  [types.CLEAR_USER_SEND_MESSAGE](state) {
    state.historyMsg = []
  },
  // 存储工程师信息
  [types.SET_ENGINEER_INFO](state, engineerInfo) {
    state.creactsessionPara = engineerInfo
  },
  // 用户发送内容
  [types.USER_SEND_MESSAGE](state, message) {
    if (message) {
      state.message.push(message)
      // for (var i = 0; i < state.message.length; i++) {
      //   for (var j = i + 1; j < state.message.length; j++) {
      //     if (state.message[i].timestamp === state.message[j].timestamp) {
      //       state.message.splice(j, 1)
      //     }
      //   }
      // }
    } else {
      alert('收到用户消息，但是未能为该用户建立会话，请联系产品经理获得帮助')
    }
  },
  // 消息发送完成回调
  [types.UPDATE_SENDING_STATE](state, { sessionId, message }) {
    state.defaultSession.messages = [...message]
  },

  // 消息发送失败，做标记
  [types.UPDATE_MESSAGE_STATE_ERROR](state, { sessionId, message }) {
    const session = state.sessions[sessionId]
    if (!session) {
      return
    }

    const target = session.messages.find(m => m.id === message.id)
    if (target) {
      target.error = 'error'
    }
  },

  // 消息接收/发送成功
  [types.UPDATE_MESSAGE_STATE_SUCCESS](state, { sessionId, message }) {
    state.message.push(message)
  },
  // 播放另一条语音的时候，其他症状播放的语音要停止
  [types.AUDIO_PLAYING](state, playItem) {
    state.audioPlaying = playItem
  },

  [types.SET_QINIU_TOKEN](state, token) {
    state.qiniu_token = token
  },
  [types.SET_SCREEN_TYPE](state, screen) {
    state.screen = screen
  },
  // 重新发送
  [types.RELOAD_CUSTOMER_IMAGE](state, message) {
  },
  // 从聊天列表中根据ID删除某条消息
  [types.DELETE_MESSAGE_FROM_LIST](state, { id }) {
    const message = state.message
    for (let i = 0; i < message.length; i++) {
      if (message[i].id === id) {
        message.splice(i, 1)
        break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/call-center/mutations.js